import { useFlags } from "launchdarkly-react-client-sdk";

/** The flag alone: an account without Transform still has data sources, syncs and connections to show. */
export function useActivityEnabled() {
  const { activityFeedEnabled } = useFlags();
  return activityFeedEnabled === true;
}

export function useActivityIsLandingPage() {
  const { activityFeedLanding } = useFlags();
  return useActivityEnabled() && activityFeedLanding === true;
}
